import { StyledGrid } from '@Utils/styles';
import {
	useGlobalization,
	StylovyzeSearchBar,
	ExportButtonWithDialogAndText,
	useCompanyDateTime,
	DataGridButton,
	DataGridButtonType,
} from '@innovyze/stylovyze';
import { Grid, Stack } from '@mui/material';
import {
	selectRiskDetailsQuery,
	selectRiskDetailsTablePage,
	selectRiskDetailsSearch,
} from '@Selectors/Risk.selectors';
import { parse } from 'query-string';
import { useDispatch } from 'react-redux';
import { changeSearch } from '@Actions/Risk.actions';
import React from 'react';
import { formatDateTimeWithFormatDate } from '@innovyze/lib_am_common/Utils';

interface TableToolbarProps {
	configId: string;
	disable: boolean;
	hasFullAccess: boolean;
	showFilterPanel: () => void;
	refreshRiskScore: () => void;
	filterRef: React.RefObject<HTMLButtonElement>;
	lastRunCompleted: string;
}

export const TableToolbar = ({
	configId,
	disable,
	hasFullAccess,
	refreshRiskScore,
	showFilterPanel,
	lastRunCompleted,
	filterRef,
}: TableToolbarProps) => {
	const { t } = useGlobalization();
	const dispatch = useDispatch();
	const { formatDate } = useCompanyDateTime();

	const queryString = selectRiskDetailsQuery();
	const tablePage = selectRiskDetailsTablePage();
	const requestParams = {
		...parse(queryString.substring(1)),
		slice: '100000',
	};

	const dispatchSearchFn = (text: string) => dispatch(changeSearch(text));

	const lastRunCompletedDiv = () => {
		if (lastRunCompleted && lastRunCompleted.length != 0)
			return (
				<div style={{ paddingTop: '6px' }}>
					{t('Results below were created on {{datetime}}', {
						datetime: formatDateTimeWithFormatDate(
							lastRunCompleted,
							formatDate,
						),
					})}
				</div>
			);
		else return [];
	};

	return (
		<StyledGrid
			alignItems="center"
			justifyContent="space-between"
			container
			style={{
				width: '100%',
				marginTop: '1rem',
				marginBottom: '1rem',
			}}>
			<Grid container xs={4}>
				<Stack>
					<StylovyzeSearchBar
						onChange={(query: string) => {
							dispatchSearchFn(query);
							refreshRiskScore();
							// dispatch(reloadRiskDetails(configId));
						}}
						onRequestSearch={() => {
							refreshRiskScore();
							// dispatch(reloadRiskDetails(configId));
						}}
						onCancelSearch={() => {
							dispatchSearchFn('');
							refreshRiskScore();
							// dispatch(reloadRiskDetails(configId));
						}}
						placeholder={t('Search')}
						value={selectRiskDetailsSearch()}
						dataCy={'search-01'}></StylovyzeSearchBar>
					{lastRunCompletedDiv()}
				</Stack>
			</Grid>
			<Grid
				item
				xs={8}
				container
				alignItems="center"
				justifyContent="flex-end"
				data-cy="grid-actionbutton"
				wrap="nowrap">
				<DataGridButton
					type={DataGridButtonType.FILTER}
					onClick={() => showFilterPanel()}
					disabled={disable}
					data-cy="filterButton"
					ref={filterRef}
				/>
				<DataGridButton
					type={DataGridButtonType.REFRESH}
					onClick={refreshRiskScore}
					disabled={disable}
					data-cy="refreshButton"
				/>
				{hasFullAccess && (
					<ExportButtonWithDialogAndText
						total={tablePage.total}
						requestParams={requestParams as Record<string, string>}
						disabled={disable}
						source={'risk.export.create'}
						title={t('Export')}
						maxRows={100000}
						dialogDataCy="export-dialog"
						iconDataCy="export-icon"
						maxPollAttempts={60}
						iterationTime={5000}
					/>
				)}
			</Grid>
		</StyledGrid>
	);
};
